import React from 'react';

/**
 * Hidden "website" input used as a bot trap. Styled so humans never see it,
 * named something a bot auto-filler is likely to target. If the field has a
 * value when the form submits, the backend silently discards the submission.
 *
 * Usage:
 *   <HoneypotField value={form.website || ''} onChange={(v) => setForm({ ...form, website: v })} />
 */
export const HoneypotField = ({ value, onChange }) => (
  <div aria-hidden="true" style={{ position: 'absolute', left: '-9999px', top: 'auto', width: '1px', height: '1px', overflow: 'hidden' }}>
    <label htmlFor="website_hp">Website</label>
    <input
      type="text"
      id="website_hp"
      name="website"
      tabIndex={-1}
      autoComplete="off"
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

export default HoneypotField;
